function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  }
}

jQuery(function($) {
  function formSubmitAjax($form) {
    return new Promise(function(resolve, reject) {
      $.ajax({
        url : $form.attr('action'),
        type: $form.attr('method'),
        data : $form.serialize(),
        dataType: 'json'
      })
      .done(function(response) {
        resolve(response);
      });      
    });
  }

  function themeCartRefresh() {
    $.getJSON('/cart.js').then(function(cart) {
      refreshCart(cart);
      $('.cart-button').click();
    });
  }

  function shogunAddToCart() {
    $(document).on('click', 'form.shg-product-atc-btn-wrapper .shg-btn', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $form = $(e.currentTarget).closest('form');
      formSubmitAjax($form).then(themeCartRefresh);
    });
  }
  
  $(document).ready(function() {
    console.log('READY');
    setTimeout(shogunAddToCart, 500);
  })
});